module.exports = __webpack_public_path__ + "static/img/blbd-img1.3081ff9a.png";